import { useEffect, useRef, useState } from "react";
import { handleFileDownload } from "../../../Utils/utilityFunctions";
import { setGlobalErrorStatus } from "../../../Components/StatusHandling";
import { ERROR_MESSAGES } from "../../../Utils/constants";
import { TextButton } from "../../../Components/Button";
import { LeftPageHeader } from "../../../Components/Public/PageHeader/PageHeader";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../Utils/PagePaths";
import CommonFormatsBody from "../../../Components/Public/CommonFormats/CommonFormatsBody";
import { useDispatch } from "react-redux";
import Feedback from "../../../Components/Public/Feedback/Feedback";

const UserAccountTypes = () => {
  // const dispatch = useDispatch();
  const sectionRefs = useRef({});
  const nav = useNavigate();
  const DUAFileGroupId = "552";
  const Issue30 = "145";
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [downloadingFiles, setDownloadingFiles] = useState([]);
  const downloadFile = (groupId) => {
    //console.log(downloadingFiles);
    if (downloadingFiles.includes(groupId)) {

    }
    else {
      setDownloadingFiles([...downloadingFiles, groupId]);
      handleFileDownload(
        groupId,
        () => {
          //console.log(document.activeElement);
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.GENERAL_ERROR.title,
              msg: ERROR_MESSAGES.GENERAL_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          })
        },
        () => {
          setDownloadingFiles(downloadingFiles.filter(f => f == groupId))
        }
      );
    }

  }

  const navToBecomeAPSO = () => {
    nav(PATHS.public['Become a PSO']);
  }

  useEffect(() => {
    setData([
      {
        level: 1,
        children: [
          {
            title: "Overview",
            level: 2,
            content: "Patient Safety Organizations (PSOs) listed by the Agency for Healthcare Research and Quality (AHRQ) and PSO affiliated vendor organizations are eligible and encouraged to create an account to access the secure pages of the Patient Safety Organization Privacy Protection Center (PSOPPC) website.",
            cardsPrologue: <>There are different types of accounts for PSOs and Vendors. Please find account registration information and instructions below each account type. User registration forms must be signed by the PSO Authorized Official via DocuSign and are provided upon request via email with PSOPPC Support at <a href={`mailto:support@psoppc.org`}>support@psoppc.org</a>.</>
          },
          {
            title: "PSO Accounts",
            level: 2,
            children: [
              {
                title: "All Registered Users",
                level: 3,
                content: "For added security, all users must set up two-factor authentication in order to log in. An authentication code will be sent to the user's designated mobile phone via SMS text message.",
              },
              {
                title: "Help Center Access",
                id: "help-center-access",
                level: 3,
                content: "For access to the PSOPPC Help Center, sign in with your PSOPPC website user ID and password and select Help Center to be redirected to a community where you can collaborate with PSOs on various topics and key Featured Topics surrounding Patient Safety.",
                cardsPrologue: "Users can use the Help Center search functionality to find articles, posts, and comments. PSOs can submit support requests inside the PSOPPC Help Center at any time. This account's registration form will be completed and electronically signed by the applicant and PSO Authorized Official using DocuSign.",
              },
              {
                title: "Level 2",
                level: 3,
                content: "Level 2 accounts provide access for PSOs to submit or update their PSO and Provider Profiles via online submission form. They can also access secure PSO reference materials and update their own account information. A Level 2 account registration form will be completed and electronically signed by the applicant and PSO Authorized Official using DocuSign.",
              },
              {
                title: "Level 3",
                level: 3,
                content: "Level 3 accounts provide access to all Level 2 functionality, allows the user to submit patient safety data for the PSO, and grants access to analytical dashboards. The user can create Patient Safety Data Submission Management Summary and Detail Reports. A Level 3 account registration form will be completed and electronically signed by the applicant and PSO Authorized Official using DocuSign. Additionally, IDology will be used for additional verification during a separately scheduled meeting with the applicant.",
              },
              {
                title: "PSO Administrator",
                level: 3,
                content: "PSO Administrator accounts provide access to all Level 3 functionality and allow the PSO Administrator to view a vendor authorization setup in the system, which will grant vendor the ability to submit on the PSO's behalf. This type of account can only be issued to the Authorized Official (AO) or Point of Contact (POC) for the PSO. A PSO Administrator account registration form will be completed and electronically signed by the applicant and PSO Authorized Official using DocuSign. Additionally, IDology will be used for additional verification during a separately scheduled meeting with the applicant.",
              },
            ]
          },
          {
            title: "Vendor Accounts",
            level: 2,
            content: <div><p>PSO-authorized vendor organizations can submit AHRQ Common Formats patient safety data on behalf of PSOs. Each vendor account will be required to submit the Vendor Registration Form for the vendor entity itself as well as its users. Please review <span onClick={() => downloadFile(Issue30)} className={`dua-pdf-link`} tabIndex={0}>Issue 30 - PSOPPC Vendor Organization Account Setup Process</span> which describes the complete process of how to successfully set up vendor organization account with the PSOPPC.</p>
              <p>Vendor accounts allow the user to submit patient safety data on behalf of a PSO. Users can create Patient Safety Data Submission Management Summary and Detail Reports. A Vendor account registration form will be completed and electronically signed by the applicant and PSO Authorized Official using DocuSign. Additionally, IDology will be used for additional verification during a separately scheduled meeting with the applicant.</p></div>,
            cardsPrologue: <div><strong>Please note:</strong> Vendor organizations can only submit patient safety data on behalf of those PSOs who have completed a Data Use Agreement (DUA). Learn more about <span onClick={() => downloadFile(DUAFileGroupId)} className={`dua-pdf-link`} tabIndex={0}>Issue 34 - Completing the Data Use Agreement (DUA)</span>.</div>,
          }
        ]
      },

    ]);
  }, [])

  const getIntro = () => {
    return (
      <>
        Agency for Healthcare Research and Quality
      </>
    )
  }

  return (
    <>
      <LeftPageHeader
        subTitle="Become a PSO"
        title="User Account Types"
        //intro={getIntro()}
        rightContent={
          <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 justify-content-center mt-2 mb-2">
            <TextButton
              //disabled={downloadingFiles.includes(allResourceGroupId)? true : false}
              className=" button-width text-center w-100 d-flex justify-content-center"
              onClick={() => navToBecomeAPSO()}
              variant="normal"
              content={"Back to Become a PSO"}
            />

          </div>
        }
      ></LeftPageHeader>

      <span className={`account-types  m-0 p-0`}>
        <CommonFormatsBody commonFormatsData={data} ref={sectionRefs} />

      </span>
      <Feedback/>
    </>
  )
};

export default UserAccountTypes;